import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ChangeRequestStatus } from '@app/core/model/change-request-statuses'

@Component({
  selector: 'change-request-tooltip',
  templateUrl: './change-request-tooltip.component.html',
  styleUrls: ['./change-request-tooltip.component.scss'],
})
export class ChangeRequestTooltipComponent {
  @Input() visible = false
  @Input() changeRequestStatus!: ChangeRequestStatus

  @Output() onSubmitDraft = new EventEmitter<void>()
  @Output() onBackToDraft = new EventEmitter<void>()
  @Output() onDismiss = new EventEmitter<void>()
  @Output() onMergeToScope = new EventEmitter<void>()

  protected readonly ChangeRequestStatus = ChangeRequestStatus

  submitDraft(): void {
    this.onSubmitDraft.emit()
  }

  backToDraft(): void {
    this.onBackToDraft.emit()
  }

  dismiss(): void {
    this.onDismiss.emit()
  }

  mergeToScope(): void {
    this.onMergeToScope.emit()
  }
}
